/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


import Vue from 'vue';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueCookie from 'vue-cookie';
import VueSession from 'vue-session';
import store from './store';
import router from './router';
import {notify} from './utils';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(VueCookie);
Vue.use(VueSession);
Vue.use(ElementUI, { locale });

Vue.config.errorHandler = function(err, vm, info) {
  if(err.name === 'NavigationDuplicated') {
    return;
  }
  notify(err.message, 'danger');
  console.error(vm);
  console.log(err);
  throw err;
};

new Vue({
  el: '#vue-main',
  store,
  router,
});
